import { FC } from "react";
import { Heading } from "../../../components/typography";
import { useThemeStore } from "../../../stores";
import useHistoryPageStore from "../store";
import { ScrollRow } from "../../../components/containers";
import ActivityRenderer from "../../../components/activity";
import { ActivityRendererType } from "../../../components/activity/types";

const HistoryResult: FC = () => {
  const theme = useThemeStore((s) => s.theme);
  const activities = useHistoryPageStore((s) => s.activities);

  return (
    <div style={{ marginTop: "1rem" }}>
      <Heading size={18} color={theme.textOnBg}>
        نتایج
      </Heading>

      <ScrollRow gap={20} height={300}>
        {activities.map((activity, idx) => (
          <ActivityRenderer
            key={idx}
            activity={activity}
            type={ActivityRendererType.Big}
          />
        ))}
      </ScrollRow>
    </div>
  );
};

export default HistoryResult;
